import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotifMessageService } from './notifmessage.service';
import { Subject, Observable, of } from 'rxjs';
import { Items } from '../models/items';
import { catchError } from 'rxjs/operators';
import { ConfigurationService } from './configuration.service';
import { AcceptanceAccount } from '../models/acceptanceaccount';

@Injectable({
  providedIn: 'root'
})
export class AcceptanceAccountsService {

  isSaveNeeded: boolean = false;

  constructor(
    private http: HttpClient,
    private configService: ConfigurationService,
    private notifService: NotifMessageService
  ) { }

  saveSubject = new Subject<boolean[]>();

  searchSubject = new Subject<AcceptanceAccount[]>();

  accaccounts: AcceptanceAccount;

  acceptanceaccountSubject = new Subject<AcceptanceAccount[]>();
  acceptanceaccountSubjectPager = new Subject<AcceptanceAccount[]>();

  acceptanceaccountSubject$ = this.acceptanceaccountSubject.asObservable();
  acceptanceaccountSubjectPager$ = this.acceptanceaccountSubjectPager.asObservable();

  emitSaveNeeded() {
    this.isSaveNeeded = true;
    this.saveSubject.next([this.isSaveNeeded]);
  }

  emitAcceptanceAccountsByPos(accaccounts) {
    this.acceptanceaccountSubject.next(accaccounts);
  }

  emitAcceptanceAccountsByMerchant(accaccounts) {
    this.acceptanceaccountSubject.next(accaccounts);
  }

  emitCriteria(criteria) {
    this.searchSubject.next(criteria);
  }

  emitacceptanceaccountPager(acceptanceaccount) {
    this.acceptanceaccountSubjectPager.next(acceptanceaccount);
  }

  // AcceptanceAccount API  calls
  findByCriteria(criteria, pager, isDeletedIncluded:boolean): Observable<Items<AcceptanceAccount>> {
    let params = {};
    Object.assign(params, pager, criteria, {includeDeleted:isDeletedIncluded});

    return this.http.get<Items<AcceptanceAccount>>(this.configService.config.urlAPI.urlAcceptanceAccount, { params: params }).pipe(catchError(err => {
      console.log("error findByCriteria", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_ACCEPTANCE_ACCOUNT_API', err);
      let emptyList = new Items<AcceptanceAccount>();
      emptyList.content = [];
      return of(emptyList);
    }));
  }

  getAcceptanceAccountById(id): Observable<AcceptanceAccount> {
    console.log("get Acceptance Account by id");
    return this.http.get<AcceptanceAccount>(`${this.configService.config.urlAPI.urlAcceptanceAccount}/${id}`).pipe(catchError(err => {
      console.log("error", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_ACCEPTANCE_ACCOUNT_API', err);
      let emptyItem = new AcceptanceAccount();
      return of(emptyItem);
    }));
  }

  findByPosIds(listPosId): Observable<Items<AcceptanceAccount>> {
    return this.http.get<any>(`${this.configService.config.urlAPI.urlAcceptanceAccount}/byPosIds?posIds=${listPosId}`).pipe(catchError(err => {
      console.log("error byids", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_ACCEPTANCE_ACCOUNT_API', err);
      let emptyList = new Array<AcceptanceAccount>();
      return of(emptyList);
    }));
  }

  findByMerchantIds(listMerchantsId): Observable<Items<AcceptanceAccount>> {
    return this.http.get<any>(`${this.configService.config.urlAPI.urlAcceptanceAccount}/byMerchantIds?merchantIds=${listMerchantsId}`).pipe(catchError(err => {
      console.log("error byids", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_ACCEPTANCE_ACCOUNT_API', err);
      let emptyList = new Array<AcceptanceAccount>();
      return of(emptyList);
    }));
  }

  createAcceptanceAccount(newAcceptanceAccount): Observable<AcceptanceAccount> {
    return this.http.post<AcceptanceAccount>(this.configService.config.urlAPI.urlAcceptanceAccount, newAcceptanceAccount).pipe(catchError(err => {
      console.log("error", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_ACCEPTANCE_ACCOUNT_API', err);
      return of(null);
    }));
  }

  deleteAcceptanceAccount(id): Observable<AcceptanceAccount> {
    return this.http.delete<AcceptanceAccount>(`${this.configService.config.urlAPI.urlAcceptanceAccount}/${id}`).pipe(catchError(err => {
      console.log("error", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_ACCEPTANCE_ACCOUNT_API', err);
      return of(null);
    }));
  }

  updateAcceptanceAccount(acceptanceaccount): Observable<AcceptanceAccount> {
    return this.http.put<AcceptanceAccount>(this.configService.config.urlAPI.urlAcceptanceAccount, acceptanceaccount).pipe(catchError(err => {
      console.log("error", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_ACCEPTANCE_ACCOUNT_API', err);
      return of(null);
    }));
  }
}
